import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PerformanceCheckComponent} from '../../components/performance-check/performance-check.component';


type Styling = {
  backgroundColor: string;
  color: string;
};
@Component({
  selector: 'app-crux-details',
  standalone: true,
  imports: [CommonModule, PerformanceCheckComponent],
  templateUrl: './crux-details.component.html',
  styleUrl: './crux-details.component.css'
})
export class CruxDetailsComponent {
@Input() chromeUXData:any = {};

  getTTFBStyling(ttfb: number): Styling {
    if (ttfb < 800) {
      return {
        color: 'white',
        backgroundColor: 'green'
      }
    }

    if (ttfb < 1800) {
      return {
        color: 'white',
        backgroundColor: 'orange'
      }
    }

    return {
      color: 'white',
      backgroundColor: 'red'
    }
  }

  getCLSStyling(cls: number): Styling {
    if (cls < 0.1) {
      return {
        color: 'white',
        backgroundColor: 'green'
      }
    }

    if (cls < 0.25) {
      return {
        color: 'white',
        backgroundColor: 'orange'
      }
    }

    return {
      color: 'white',
      backgroundColor: 'red'
    }
  }

  getLCPStyling(lcp: number): Styling {
    if (lcp < 2500) {
      return {
        color: 'white',
        backgroundColor: 'green'
      }
    }

    if (lcp < 4000) {
      return {
        color: 'white',
        backgroundColor: 'orange'
      }
    }

    return {
      color: 'white',
      backgroundColor: 'red'
    }
  }
}
